import "./button.component.css";

function Button({ text, isDark = false, onClick }) {
  return (
    <button
      className={`app-button ${isDark ? "dark" : "light"}`}
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default Button;
